<template>
	<div class="teaming-hint">
		<slot></slot>
	</div>
</template>

<script>

export default {
	name: "TeamingHint",
};
</script>

<style lang="scss" scoped>
.teaming-hint {
	display: inline-flex;
	@include font-and-line-for(-1);
	text-align:left;
	color: $teaming-hint-color;
}
</style>
